import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { my_routes } from "../router/all_routes";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { SubmitHandler, useForm } from "react-hook-form";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { createParent } from "../../api/parents";
import { useAcademicYear } from "../../core/common/context/AcademicYearContext";
import { getAllStudentByYear } from "../../api/etudiants";
import { getAllTypeLink } from "../../api/studentParent";
import { createStudentParent } from "../../api/studentParent";
import { Select } from "antd";
import { toast } from "sonner";

// pour restreaindre l'accès à ce composant
import withPermission from "../../core/common/autorisations/withPermission";
import {
  Action,
  buildPermission,
  buildPermissionContext,
  Resource,
} from "../../core/common/autorisations/permissionsMap";

interface CreateParentModalProps {
  setAllParents?: React.Dispatch<React.SetStateAction<any[]>>;
  updateData?: React.Dispatch<React.SetStateAction<boolean>>;
}

enum Sexe {
  Masculin = "Masculin",
  Feminin = "Feminin",
}
//  shéma pour la vérification des enfants

const childShema = z.object({
  id: z.string(),
  value: z.string(),
  label: z.string(),
  relation: z
    .object({
      id: z.string(),
      label: z.string(),
    })
    .nullable()
    .refine((val) => val !== null && val !== undefined, {
      message: "La relation est obligatoire",
    }),
});

const childrenArrayShema = z.array(childShema);

// Schema de notre formulaire de création de compte
const schema = z.object({
  lastname: z.string().nonempty("Veuillez insérer un nom"),
  firstname: z.string().nonempty("Veuillez insérer un prénom"),
  sexe: z.nativeEnum(Sexe, {
    errorMap: () => ({ message: "Veuillez sélectionner un genre valide." }),
  }),
  isDeceased: z.boolean(),
  email: z
    .string()
    // .email("Veuillez fournir une adresse email valide")
    .optional(),
  number: z
    .string()
    // .regex(
    //   /^(\+223)?[456789]\d{7}$/,
    //   "Numéro de téléphone invalide. Ex: +22370123456 ou 70123456"
    // )
    .optional(),
  adresse: z.string().optional(),
  statut: z.enum(["true", "false"], {
    required_error: "Veuillez sélectionner un statut",
  }),
});

type FormFields = z.infer<typeof schema>;

const CreateParentModal: React.FC<CreateParentModalProps> = ({
  setAllParents,
  updateData,
}) => {
  const navigate = useNavigate();
  const routes = my_routes;
  const { selectedYear } = useAcademicYear();
  const [childs, setChilds] = useState<
    {
      id: string;
      value: string;
      label: string;
      relation: { id: string; label: string } | null;
    }[]
  >([]);

  const [allStudents, setAllStudents] = useState<
    {
      id: string;
      value: string;
      label: string;
      relation: { id: string; label: string } | null;
    }[]
  >([]);
  const [allTypeLink, setAllTypeLink] = useState<
    { id: string; label: string }[]
  >([]);
  //   Initialisation de zod avec react-hook-form
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    setError,
    reset,
    clearErrors,
    formState: { errors, isSubmitting },
  } = useForm<FormFields>({
    resolver: zodResolver(schema),
    defaultValues: {
      statut: "true",
    },
  });

  const isDeceasedValue = watch("isDeceased");

  const getModalContainer = () => {
    const modalElement = document.getElementById("add_parent_modal");
    return modalElement ? modalElement : document.body; // Fallback to document.body if modalElement is null
  };
  useEffect(() => {
    if (selectedYear) {
      getAllStudentByYear(
        selectedYear.id,
        buildPermissionContext(Resource.PARENT, Action.CREATE),
      )
        .then(async (response) => {

          const result = response.data.map((student: any) => {
            if (selectedYear) {
              // console.log("Studentdata: ", student);
              const formattedData = selectedYear
                ? {
                    ...student,
                    class: student?.Registrations[0]?.Class,
                    academicYear: student?.Registrations[0]?.AcademicYear,
                  }
                : { ...student };
              return formattedData;
            } else {
              const formattedData = { ...student };
              return formattedData;
            }
          });

          const formattedChilds = result.map((child: any) => ({
            id: child.id,
            value: child.id,
            label: ` ${child?.class?.Level.label || ""} - ${child?.class.label || ""} : ${child.firstname} ${child.lastname}`,
            relation: null,
          }));
          // console.log("formattedChilds: ", formattedChilds);
          setAllStudents(formattedChilds);
        })
        .catch((error: any) => {
          // console.error("Erreur lors de la récupération des enfants :", error);
          toast.error(
            error.response?.data?.message ||
              error.response?.data?.error ||
              error.message ||
              "Une erreur s'est produit, Réessayer plus tard",
          );

        });
    } else {
      toast.error("Aucune Année académique trouvé !");
    }
    getAllTypeLink(buildPermissionContext(Resource.PARENT, Action.CREATE))
      .then((response) => {
        const formattedLink = response.data.map((link: any) => ({
          id: link.id,
          label: link.type,
        }));
        setAllTypeLink(formattedLink);
      })
      .catch((error) => {
        // console.error(
        //   "Erreur lors de la récupération des types de liens: ",
        //   error,
        // );
        toast.error(
          error.message ||
            error?.response?.data?.message ||
            error?.response?.data?.error ||
            "Erreur ,veuillez ressaye plus tard .",
        );
      });
  }, []);

  useEffect(() => {
    // Si le statut de décès est "true", on met le statut à "false"
    // car un parent décédé ne peut pas être actif
    if (isDeceasedValue === true) {
      setValue("statut", "false");
      setValue("email", "");
      setValue("adresse", "");
      setValue("number", "");
    }
  }, [isDeceasedValue, setValue]);

  // Fonction de soumission du formulaire
  const onSubmit: SubmitHandler<FormFields> = async (data) => {
    try {
      // vérifie les enfants sélectionnés
      const validation = childrenArrayShema.safeParse(childs);

      if (!validation.success) {
        const errorMessage =
          validation.error.errors[0]?.message ||
          "Un ou plusieurs enfants ont un format invalide ou une relation manquante.";
        setError("root", { message: errorMessage });
        return;
      }

      // on convertie le champ statut et isDeceased en boolean
      const formData = {
        ...data,
        statut: data.statut === "true",
        email: data.email === "" ? undefined : data.email,
      };

      // console.log("formData: ", formData);
      // Appel à l'API pour créer le parent
      const res_1 = await createParent(formData);

      if (childs) {
        const parentCreated = res_1.user;

        // Si des enfants sont sélectionnés, on les associe au parent
        if (parentCreated)
          await Promise.all(
            childs.map((child) =>
              createStudentParent({
                id_student: child.id,
                id_parent: parentCreated.id,
                id_link: child.relation?.id,
              }),
            ),
          );
      }
      if (updateData) updateData(true);

      //  mettre à jour le state
      if (setAllParents)
        setAllParents((prev) => [
          ...prev,
          { ...formData, createdAt: Date.now() },
        ]);

      // fermer le modal si nécessaire
      const btn = document.getElementById("cancel-btn");
      if (btn) {
        btn.click();
      }
      // Redirection vers la page des parents
      navigate(routes.allParent, {
        state: { successMessage: "Parent créé avec succès" },
      });
    } catch (error: any) {
      // Gérer les erreurs de l'API
      // console.log(error);
      setError("root", {
        message:
          error.response?.data?.message ||
          error.response?.data?.error ||
          "une erreur inattendu c'est produite veuillez ésssyez plus tard",
      });
    }
  };

  // Fonction pour gérer la sélection des enfants
  const handleChildrenChange = (
    selectedIds: string[],
    option?:
      | {
          id: string;
          value: string;
          label: string;
          relation: { id: string; label: string } | null;
        }
      | {
          id: string;
          value: string;
          label: string;
          relation: { id: string; label: string } | null;
        }[]
      | undefined,
  ) => {
    // option peut être undefined ou un tableau ou un objet, donc on doit gérer les cas
    let selectedOptions: {
      id: string;
      value: string;
      label: string;
      relation: { id: string; label: string } | null;
    }[] = [];
    if (Array.isArray(option)) {
      selectedOptions = option as {
        id: string;
        value: string;
        label: string;
        relation: { id: string; label: string } | null;
      }[];
    } else if (option) {
      selectedOptions = [
        option as {
          id: string;
          value: string;
          label: string;
          relation: { id: string; label: string } | null;
        },
      ];
    } else {
      // fallback: reconstruire à partir des valeurs sélectionnées
      selectedOptions = allStudents.filter((child) =>
        selectedIds.includes(child.id),
      );
    }
    // Ajoute la propriété relation: null par défaut si elle n'existe pas
    const newSelectedChildren = selectedOptions.map((child) => ({
      ...child,
      relation: child.relation ?? null,
    }));
    setChilds(newSelectedChildren);
  };

  // Pour changer la relation avec un etudiant
  const updateRelation = (childId: string, relationLabel: string) => {
    const matchedLink = allTypeLink.find(
      (link) => link.label === relationLabel,
    );

    if (!matchedLink) {
      console.warn(`Aucune relation trouvée pour ce label : ${relationLabel}`);

      return;
    }

    setChilds((prev) =>
      prev.map((child) =>
        child.id === childId ? { ...child, relation: matchedLink } : child,
      ),
    );
  };

  return (
    <div className="modal fade " id="add_parent_modal">
      <div className="modal-dialog modal-dialog-centered ">
        <div className="modal-content">
          <div className="modal-header">
            <h4 className="modal-title">Ajout d'un Parent</h4>
            <button
              id="closeBtn-passwordModal"
              type="button"
              className="btn btn-sm btn-danger"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <i className="ti ti-x" />
            </button>
          </div>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="modal-body pb-0">
              {errors.root && (
                <div className="alert alert-danger">{errors.root.message}</div>
              )}
              <div className="d-grid d-xl-flex gap-0 gap-xl-3d-block d-xl-flex gap-3">
                <div className="mb-3 flex-fill">
                  <label className="form-label">Nom</label>
                  <input
                    type="text"
                    placeholder="Entrer un nom"
                    className={`form-control ${
                      errors.lastname ? "is-invalid" : ""
                    }`}
                    {...register("lastname")}
                  />
                  {errors.lastname && (
                    <div className="invalid-feedback">
                      {errors.lastname.message}
                    </div>
                  )}
                </div>

                <div className="mb-3 flex-fill">
                  <label className="form-label">Prénom</label>
                  <input
                    type="text"
                    placeholder="Entrer un prenom"
                    className={`form-control ${
                      errors.firstname ? "is-invalid" : ""
                    }`}
                    {...register("firstname")}
                  />
                  {errors.firstname && (
                    <div className="invalid-feedback">
                      {errors.firstname.message}
                    </div>
                  )}
                </div>
              </div>

              <div className="d-block d-xl-flex">
                <div className="mb-3 flex-fill me-xl-3 me-0">
                  <label className="form-label">Sexe</label>
                  <select
                    className={`form-select ${errors.sexe ? "is-invalid" : ""}`}
                    {...register("sexe")}
                  >
                    <option value="">Sélectionner le sexe</option>
                    <option value="Masculin">Homme</option>
                    <option value="Feminin">Femme</option>
                  </select>
                  {errors.sexe && (
                    <div className="invalid-feedback">
                      {errors.sexe.message}
                    </div>
                  )}
                </div>

                <div className="m-auto flex-fill ">
                  <div className="form-check form-check-lg form-switch">
                    <label className="form-check-label">Statut du Décès</label>
                    <input
                      {...register("isDeceased")}
                      className="form-check-input"
                      type="checkbox"
                      role="switch"
                      id="switch-lg"
                    />
                  </div>
                  {errors.isDeceased && (
                    <div className="invalid-feedback">
                      {errors.isDeceased.message}
                    </div>
                  )}
                </div>
              </div>
              {!isDeceasedValue && (
                <div className="mb-3">
                  <label className="form-label">Adresse</label>
                  <textarea
                    placeholder="Exemple : Badalabougou, Commune 5, Rue 300 Porte 218"
                    rows={4}
                    cols={8}
                    className={`form-control ${
                      errors.adresse ? "is-invalid" : ""
                    }`}
                    {...register("adresse")}
                  />
                  {errors.adresse && (
                    <div className="invalid-feedback">
                      {errors.adresse.message}
                    </div>
                  )}
                </div>
              )}
              {/* <div className="d-block d-xl-flex"> */}
                {!isDeceasedValue && (
                  // <div className=" mb-3 flex-fill me-xl-3 me-0">
                  <>
                    <div className="mb-3">
                      <label className="form-label">Email</label>
                      <input
                        type="email"
                        placeholder="Ex. example@gmail.com"
                        // disabled={register("isDeceased")}
                        className={`form-control ${
                          errors.email ? "is-invalid" : ""
                        }`}
                        {...register("email")}
                      />
                      {errors.email && (
                        <div className="invalid-feedback">
                          {errors.email.message}
                        </div>
                      )}
                    </div>
                  <div className="d-block d-xl-flex garap-0 gap-xl-3"> 
                    
                    <div className="mb-3">
                      <label className="form-label">Numéro de téléphone</label>
                      <input
                        type="text"
                        placeholder="Ex. +223 84382001 "
                        className={`form-control ${
                          errors.number ? "is-invalid" : ""
                        }`}
                        {...register("number")}
                      />
                      {errors.number && (
                        <div className="invalid-feedback">
                          {errors.number.message}
                        </div>
                      )}
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Statut</label>
                      <select
                        className={`form-select ${
                          errors.statut ? "is-invalid" : ""
                        }`}
                        {...register("statut")}
                      >
                        <option value="">Sélectionner le statut</option>
                        <option value="true" selected>
                          Actif
                        </option>
                        <option value="false">Inactif</option>
                      </select>
                      {errors.statut && (
                        <div className="invalid-feedback">
                          {errors.statut.message}
                        </div>
                      )}
                    </div>
                  </div>
                  </>
                )}
                {/* Selection enfants */}
                <div className="mb-6 flex-fill my-2">
                  <label htmlFor="" className="form-label">
                    Etudiants
                  </label>
                  <br />
                  <Select
                    id="child-selector"
                    mode="multiple"
                    allowClear
                    className="select"
                    getPopupContainer={getModalContainer}
                    style={{
                      maxWidth: "500px",
                      width: "100%",
                    }}
                    placeholder="Please select"
                    defaultValue={[]}
                    value={childs.map((child) => child.id)}
                    options={allStudents}
                    onChange={handleChildrenChange}
                    // Permet de chercher par nom/prenom a lieu de l'id
                    filterOption={(input, option) =>
                      (option?.label ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                  />
                  {childs.length > 0 && (
                    <div className="mt-2">
                      <h6 className="mb-2">Etudiants sélectionnés :</h6>
                      <ul className="list-group">
                        {childs.map((child) => (
                          <li
                            key={child.id}
                            className="list-group-item d-flex justify-content-between align-items-center mb-2"
                          >
                            <span>{child.label}</span>
                            <select
                              name=""
                              id=""
                              className="form-select ms-2"
                              style={{ maxWidth: "200px" }}
                              value={child.relation?.label ?? ""}
                              onChange={(e) =>
                                updateRelation(child.id, e.target.value)
                              }
                            >
                              <option value="">Choisir une relation</option>
                              {allTypeLink.map((link) => (
                                <option key={link.id} value={link.label}>
                                  {link.label}
                                </option>
                              ))}
                            </select>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
              {/* </div> */}
            </div>
            <div className="modal-footer">
              <Link
                to="#"
                id="cancel-btn"
                className="btn btn-light me-2"
                data-bs-dismiss="modal"
                onClick={() => {
                  reset();
                  clearErrors();
                  setChilds([]);
                }}
              >
                Annuler
              </Link>
              {isSubmitting ? (
                <button
                  className="btn btn-primary-light"
                  type="button"
                  disabled={true}
                >
                  <span
                    className="spinner-border spinner-border-sm align-middle me-1 "
                    role="status"
                    aria-hidden="true"
                  />
                  Loading...
                </button>
              ) : (
                <button
                  type="submit"
                  className="btn btn-primary"
                  // data-bs-dismiss="modal"
                >
                  Ajouter
                </button>
              )}
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default withPermission(
  CreateParentModal,
  [buildPermission(Resource.PARENT, Action.CREATE)],
  "masquer",
);
